<template>
    <div class="empty-page">
      <div class="content">
        <img src="@/assets/image/empty@3x.png" alt="Empty Icon" class="empty-image" />
        <div class="empty-text">{{ displayContent }}</div>
        <div class="btn" v-if="showBtn" @click="router.push({ path: '/home/controlDeveloperAuth'})">{{$t('personalCenter.certifiedDeveloper')}}</div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue'
  import { useRouter } from 'vue-router'
  import { useI18n } from "vue-i18n";
  const { t } = useI18n();

  const router = useRouter()
    defineProps({
        content: {
            type: String,
            default: '',   // 暂无内容
        },
        showBtn: {
            type: Boolean,
            default: false,
        }
    });

  const displayContent = computed(() => {
    return t('document.noContent')
  })
  </script>
  
  <style lang="scss" scoped>
  .empty-page {
    width: 100%;
    height: 100vh; 
    background-color: #f8f8f8; 
    padding: 24px 120px 40px; 
    box-sizing: border-box; 
  }
  
  .content {
    width: 100%; 
    height: 100%; 
    background-color: white; 
    border-radius: 8px; 
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); 
    display: flex;
    flex-direction: column;
    justify-content: center; 
    align-items: center; 
    text-align: center;
  }
  
  .empty-image {
    width: 200px; 
    height: auto; 
    margin-bottom: 24px; 
  }
  
  .empty-text {
    font-size: 18px; 
    color: rgba(51, 51, 51, .4); 
    margin-bottom: 24px; 
  }

  .btn{
    background: #386AEA;
    font-size: 20px;
    padding: 16px 29px;
    border-radius: 4px;
    color: #fff;
  }

  </style>